import React, { useEffect, useState } from 'react';

import { Dialog, DialogContent, DialogTitle } from '@/Components/shadcn';
import TMWingsAnimation from '@/Components/Animations/TMWingsAnimation/TMWingsAnimation';
import UIStrings from '@/Utils/UIStrings';

interface ExperienceStepRecalculationDialogProps {
    open: boolean;
}

function ExperienceStepRecalculationDialog({ open }: ExperienceStepRecalculationDialogProps): React.JSX.Element {
    const [dots, setDots] = useState('');

    useEffect(() => {
        const animationIntervalId = setInterval(() => {
            setDots((prevDots) => (prevDots.length < 3 ? `${prevDots}.` : ''));
        }, 500); // Change dot every 500ms

        return () => {
            clearInterval(animationIntervalId); // Clean up on unmount
        };
    }, []);

    return (
        <Dialog open={open}>
            <DialogContent
                showCloseButton={false}
                className="flex max-w-xl flex-col items-center px-5 pt-4 pb-2.5"
                onPointerDownOutside={(event) => event.preventDefault()}
                onEscapeKeyDown={(event) => event.preventDefault()}
            >
                <DialogTitle className="text-foreground text-center text-2xl font-semibold">
                    {UIStrings.PleaseWaitForAMoment}
                </DialogTitle>
                <p className="text-foreground text-base">{UIStrings.RecalculatingExperienceScore + dots}</p>
                <div className="mt-2.5">
                    <TMWingsAnimation width={217} height={164} />
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default ExperienceStepRecalculationDialog;
